module.exports = __webpack_public_path__ + "static/media/I_bubbly_ui.af970cbf.png";